import Web3 from 'web3';
import config from '../Config';

const web3 = new Web3(config.rpcUrl);

export default web3;